import { useEffect, useState } from 'react'

import { DelayProvider, useDelayContext } from '@/components/ui/Delay'
import { FadeSlideAnimation } from '@/components/ui/FadeSlideAnimation'

export function TypingDots() {
  return (
    <div className="mb-6 flex gap-1 py-3">
      <span className="bg-ink-400 size-1.5 animate-bounce rounded-full [animation-delay:0ms]" />
      <span className="bg-ink-400 size-1.5 animate-bounce rounded-full [animation-delay:150ms]" />
      <span className="bg-ink-400 size-1.5 animate-bounce rounded-full [animation-delay:300ms]" />
    </div>
  )
}

interface TypingIndicatorProps {
  visible: boolean
  withInitialDelay?: boolean
}

export function TypingIndicator({ visible, withInitialDelay = true }: TypingIndicatorProps) {
  const [active, setActive] = useState(!withInitialDelay && visible)

  useEffect(() => {
    if (!visible) {
      setActive(false)
      return
    }
    if (!withInitialDelay) {
      setActive(true)
      return
    }
    const delay = 100 + Math.random() * 500
    const timeout = setTimeout(() => setActive(true), delay)
    return () => clearTimeout(timeout)
  }, [visible, withInitialDelay])

  return (
    <DelayProvider initiallyVisible={false}>
      <VisibilitySync visible={active} />
      <FadeSlideAnimation>
        <TypingDots />
      </FadeSlideAnimation>
    </DelayProvider>
  )
}

function VisibilitySync({ visible }: { visible: boolean }) {
  const { setVisible } = useDelayContext()
  useEffect(() => {
    setVisible(visible)
  }, [visible, setVisible])
  return null
}
